/**
 * @generated SignedSource<<0baae88a7d023591d6f6e350ab6730ef>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DeleteAssetTrackButtonMutation$variables = {
  id: string;
};
export type DeleteAssetTrackButtonMutation$data = {
  readonly deleteAssetTrack: {
    readonly deletedAssetTrackId: string | null;
  };
};
export type DeleteAssetTrackButtonMutation = {
  response: DeleteAssetTrackButtonMutation$data;
  variables: DeleteAssetTrackButtonMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedAssetTrackId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteAssetTrackButtonMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteAssetTrackResponse",
        "kind": "LinkedField",
        "name": "deleteAssetTrack",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteAssetTrackButtonMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteAssetTrackResponse",
        "kind": "LinkedField",
        "name": "deleteAssetTrack",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteRecord",
            "key": "",
            "kind": "ScalarHandle",
            "name": "deletedAssetTrackId"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "af6186244df65665d2f56e03c45d8f89",
    "id": null,
    "metadata": {},
    "name": "DeleteAssetTrackButtonMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteAssetTrackButtonMutation(\n  $id: ID!\n) {\n  deleteAssetTrack(id: $id) {\n    deletedAssetTrackId\n  }\n}\n"
  }
};
})();

(node as any).hash = "6d1bc537b277352574fbeb83183c9f59";

export default node;
